import { t } from "i18next";
import { z } from "zod";

import { StakeholderRoleEnum } from "src/core/constants/folder";
import { nameRule } from "src/core/forms/validators/rules";

export const addStakeholderBasicSchema = () =>
  z.object({
    roles: z.array(z.nativeEnum(StakeholderRoleEnum)).refine((roles) => roles.length > 0, {
      message: t("global.form.error.mandatoryField"),
    }),
    firstName: nameRule(t, { checkIfShown: true, required: true }),
    lastName: nameRule(t, { checkIfShown: true, required: true }),
  });

export type AddStakeholderBasicFormValues = z.infer<ReturnType<typeof addStakeholderBasicSchema>>;

export const defaultAddStakeholderBasicValues: AddStakeholderBasicFormValues = {
  roles: [],
  firstName: "",
  lastName: "",
};
